import styled from 'styled-components';

const ContentContainer = styled.div`
  width: 100%;
  height: 100%;

  max-width: 1240px;
  margin: 0 auto;
`;

export default ContentContainer;
